import clearAgencyTwilio from './clear-agency-twilio'
import generateMapPhoneNumberSID from './generate-map-phone-number-sid'
import setDefaultOutboundNumber from './set-default-inbound-number'
import setNumberPoolsLookupTable from './set-number-pools-lookup-table'
import setPhoneNumbersLookupTable from './set-phone-numbers-lookup-table'
import setTollFreeRequests from './set-tollfree-requests'
import setTable from './set-table'
import setPhoneNumbersA2PLookup from  "./set-phone-numbers-a2p-lookup"

const mutations = {
  clearAgencyTwilio,
  generateMapPhoneNumberSID,
  setDefaultOutboundNumber,
  setNumberPoolsLookupTable,
  setPhoneNumbersLookupTable,
  setTollFreeRequests,
  setTable,
  setPhoneNumbersA2PLookup,

  setStripe(state, payload: any) {
    state.stripe = payload
  },

  setAgencyTwilio(state, payload) {
    state.agencyTwilio = payload
  },

  startLoading(state) {
    state.loading = true
  },

  startModalLoading(state) {
    state.modalLoading = true
  },

  stopLoading(state) {
    state.loading = false
  },

  stopModalLoading(state) {
    state.modalLoading = false
  },

  setLocationId(state, locationId: string) {
    state.locationId = locationId
  },

  setTableRecordsCount(state, renderedRecordsCount: number) {
    state.renderedRecordsCount = renderedRecordsCount ?? 0
  },

  setTotalPhoneNumbers(state, totalPhoneNumbers: number) {
    state.totalPhoneNumbers = totalPhoneNumbers
  },

  setTotalNumberPools(state, totalNumberPools: number) {
    state.totalNumberPools = totalNumberPools
  },

  setTotalVerifiedCallerIDs(state, totalVerifiedCallerIDs: number) {
    state.totalVerifiedCallerIDs = totalVerifiedCallerIDs
  },

  setPhoneNumbers(state, phoneNumbers: any[]) {
    state.phoneNumbers = []
    state.phoneNumbers = phoneNumbers
  },

  setNumberPools(state, numberPools: any[]) {
    state.numberPools = []
    state.numberPools = numberPools
  },

  setNumberPoolIDs(state, numberPoolIDs: string[]) {
    state.numberPoolIDs = []
    state.numberPoolIDs = numberPoolIDs
  },

  setLocationTwilio(state, locationTwilio: any) {
    state.locationTwilio = {}
    state.locationTwilio = locationTwilio
  },

  setCallerIDs(state, callerIDs: any[]) {
    state.callerIDs = []
    state.callerIDs = callerIDs
  },

  clearPhoneNumbersLookupTable(state) {
    state.phoneNumbersSIDIndexLookup = {}
  },

  clearMapPhoneNumberSID(state) {
    state.mapPhoneNumberSID = {}
  }
}


export default mutations
